The input parameter for the `createUnpostedPositionProfileForOpening` mutation.
